import { useState, useEffect } from 'react';
import { Singleton } from "../../../../core/services/Singleton";
import useModal, { MODAL_LG, MODAL_SM } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { toast } from 'react-toastify';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { ModalConfirm } from '../../../theme/Component/ModalConfirm';
import { SelectBudgetID } from '../../../admin/configuracion/BudgetID/SelectBudgetID';
import { BasicSwitch } from '../../../theme/Component/BasicSwitch';
import { AccountEditor } from '../../../editor/AccountEditor';
import useAccountantTree, { VIEW_EDITOR } from './useAccountantTree';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import { CostingCenterSelect } from '../../../erp/cellEditor/CostingCenter/CostingCenterSelect';
import { SelectAccountantTree } from './SelectAccountantTree';
import { Selecttofile } from '../../../Talentohumano/GestionTH/PaymentAccount/Selecttofile';
import { SelectTypeProcees } from '../../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees';
import { SelectRecurso } from '../../../Factoty&Production/LabourType/SelectRecurso';
import { EditorPaymentFile } from '../PaymentFile/EditorPaymentFile';
import { SelectBusinessCore } from '../../../erp/cellEditor/BusinessCore/SelectBusinessCore';
import { PrintJson } from '../../../theme/Component/PrintJson';
import { ConfigSIIFTCON6ValueByAccountantID } from './ConfigSIIFTCON6ValueByAccountantID';


interface Props {
    id: number;
    idAccountantIDType: number;
    bean: any;
    updateEvent: any;

}
export const ButtonAccountantTree = ({ id, idAccountantIDType, bean, updateEvent }: Props) => {

    const single = Singleton.getInstance();
    const { makeList, makeCodeFormat, createAccountantID, cargarChilds, accountantID } = useAccountantTree(VIEW_EDITOR);


    const [miBean, setMibean] = useState<any>({});
    const [cuenta, setCuenta] = useState<number>(1);
    const [nombre, setNombre] = useState<string>('');
    const [idBudgetType, setIDBudgetType] = useState<number>(0);
    const [cuentaFormat, setCuentaFomat] = useState<string>('');

    const modalCrear = useModal("Crear cuenta", MODAL_LG);
    const confirmDelete = useModal("Cuenta contable", MODAL_SM);
    const siif = useModal("Configurar Parámetros de SIIF Nación / TCON16", MODAL_LG);


    useEffect(() => {
        setCuenta(bean.AccountantID);
        setNombre(bean.Name);
        setMibean(bean);
    }, [bean])
    useEffect(() => {
        setMibean({ ...miBean, "Name": nombre });
    }, [nombre])



    useEffect(() => {


        if (cuenta >= 1) {
            let format = makeCodeFormat(cuenta);
            if (format)
                setCuentaFomat(format);
            else {
                setCuentaFomat("##");
                toast.warning("La cuenta es muy larga");
            }

        }
        setMibean({ ...miBean, "AccountantID": cuenta });
    }, [cuenta])



    const createAccountant = () => {
        let lista = makeList(cuenta);
        if (lista.length > 0 && nombre != '') {
            createAccountantID(idAccountantIDType, lista, nombre).then((resp: any) => {
                updateEvent();
                _single.deleteCacheItem("AccountantIDType");
                _single.deleteCacheItem("TreeForAccountantID");
                _single.deleteCacheItem("AccountantIDTree_");
                modalCrear.close();
            })
        } else {
            toast.error("Datos incompletos");
        }

    }
    const updateAccountant = () => {

        let b = miBean;
        accountantID.updateCustonBean(b).then(
            (resp: any) => {
                updateEvent();
                _single.deleteCacheItem("AccountantIDType");
                _single.deleteCacheItem("TreeForAccountantID");
                _single.deleteCacheItem("AccountantIDTree_");
                modalCrear.close()
            }
        )

    }

    const deleteAccountant = (idln: number) => {
        accountantID.deleteItem(idln).then(
            (resp: any) => {
                updateEvent();
                _single.deleteCacheItem("AccountantIDType");
                _single.deleteCacheItem("TreeForAccountantID");
                _single.deleteCacheItem("AccountantIDTree_");
                confirmDelete.close()
            }
        )

    }

    return (
        <>

            {single.canCreate() &&
                <i className="ri-file-add-line cursor btnicon_sm" title="Agregar Hijo" onClick={() => {
                    modalCrear.open();
                    setMibean({});
                }}></i>
            }
            {(single.canDelete() && bean.IDLn) &&
                <i className="ri-file-reduce-line cursor btnicon_sm" title="Eliminar" onClick={() => { confirmDelete.open(); }}></i>
            }
            {(single.canEdit() && bean.IDLn) &&
                <i className="ri-edit-2-line cursor btnicon_sm" title="Editar" onClick={() => {
                    modalCrear.open();
                    setMibean(bean);
                }}></i>
            }
            {(single.canEdit() && bean.IDLn) &&
                <i className="ri-file-settings-line cursor btnicon_sm" title="Configurar Parámetros de SIIF Nación / TCON16" onClick={() => {
                    siif.open();
                    setMibean(bean);
                }}></i>
            }

            <Modal modal={modalCrear.modal} updateModal={modalCrear.setModal}>
                <div className="row">

                    <div className="col-md-6">
                        <label>Código : <strong>{cuentaFormat}</strong> </label>
                        <input type="number" className="form-control" value={cuenta} onChange={(e) => { setCuenta(parseInt(e.target.value)) }} />
                    </div>
                    <div className="col-md-6">
                        <label> Nombre cuenta </label>
                        <input type="text" className="form-control" value={nombre} onChange={(e) => { setNombre(e.target.value) }} />
                    </div>

                    {miBean.IDLn &&
                        <>
                            <div className="col-md-12">
                                <SelectBudgetID tipoPresupuesto={0} edit={false} idBudgetID={miBean.IDBudgetID} onChange={(e: any) => { setMibean({ ...miBean, "IDBudgetID": e.IDLn }) }} />
                            </div>
                            <hr className='mt-2 mb-2' />
                            <div className="col-md-4">
                                <BasicSwitch label='Requiere Centro de Costo' estado={miBean.RequiresCostingCenter} eventChange={(e: any) => { setMibean({ ...miBean, "RequiresCostingCenter": e }) }} />
                            </div>
                            <div className="col-md-4">
                                <BasicSwitch label='Código Otro PUC' estado={miBean.OtherPUCCode} eventChange={(e: any) => { setMibean({ ...miBean, "OtherPUCCode": e }) }} />
                            </div>
                            <div className="col-md-4">
                                <BasicSwitch label='Requiere Tercero' estado={miBean.RequiresThird} eventChange={(e: any) => { setMibean({ ...miBean, "RequiresThird": e }) }} />
                            </div>
                            <div className="col-md-4">
                                <BasicSwitch label='Requiere Área Funcional' estado={miBean.RequiresArea} eventChange={(e: any) => { setMibean({ ...miBean, "RequiresArea": e }) }} />
                            </div>
                            <div className="col-md-4">
                                <BasicSwitch label='Requiere Proyecto' estado={miBean.RequiresProject} eventChange={(e: any) => { setMibean({ ...miBean, "RequiresProject": e }) }} />
                            </div>

                            <div className="col-md-4">
                                <BasicSwitch label='Requiere Sucursal' estado={miBean.RequiresSucursal} eventChange={(e: any) => { setMibean({ ...miBean, "RequiresSucursal": e }) }} />
                            </div>

                            <div className="col-md-4">
                                <BasicSwitch label='Utilizar Archivo de Cuentas por Pagar' estado={miBean.PaymentFile} eventChange={(e: any) => { setMibean({ ...miBean, "PaymentFile": e }) }} />
                                {miBean.PaymentFile &&
                                    <EditorPaymentFile idValue={bean.IDPaymentFile} label='Archivo de Cuentas por Pagar' onChange={(e) => { setMibean({ ...miBean, IDPaymentFile: e.IDPaymentFile }) }} />
                                }
                            </div>
                            <div className="col-md-4">
                                <BasicSwitch label='Cuentas por Cobrar/Anticipos a Proveedores' estado={miBean.Receivable} eventChange={(e: any) => { setMibean({ ...miBean, "Receivable": e }) }} />
                            </div>
                            <div className="col-md-4">
                                <BasicSwitch label='Cuenta por Pagar/Anticipos de Clientes' estado={miBean.Payeable} eventChange={(e: any) => { setMibean({ ...miBean, "Payeable": e }) }} />
                            </div>
                            <div className="col-md-4">
                                <BasicSwitch label='Consolidar Terceros en una Cuenta por Pagar' estado={miBean.RequiresConsolidateThird} eventChange={(e: any) => { setMibean({ ...miBean, "RequiresConsolidateThird": e }) }} />
                                {miBean.RequiresConsolidateThird &&
                                    <>
                                        <AccountEditor idAccount={miBean.IDAccountThird} label='Tercero que consolida' onChange={({ IDAccount }) => { setMibean({ ...miBean, "IDAccountThird": IDAccount }) }} />
                                    </>

                                }
                            </div>
                            <hr className='mt-2 mb-2' />

                            <div className="col-md-4">
                                <label>Área por Defecto</label>
                                <input type="text" className='form-control' value={miBean.DefaultArea} onChange={(e) => { setMibean({ ...miBean, "DefaultArea": e.target.value }) }} />
                            </div>
                            <div className="col-md-4">
                                <label>Proyecto por Defecto</label>
                                <input type="text" className='form-control' value={miBean.DefaultArea} onChange={(e) => { setMibean({ ...miBean, "DefaultProject": e.target.value }) }} />
                            </div>
                            <div className="col-md-4">
                                <label>Sucursal por Defecto</label>
                                <input type="text" className='form-control' value={miBean.DefaultSucursal} onChange={(e) => { setMibean({ ...miBean, "DefaultSucursal": e.target.value }) }} />
                            </div>
                            <div className="col-md-4">
                                <CostingCenterSelect label="Centro de Costo por Defecto" idSelector={miBean.DefaultCostingCenter} onChange={(e) => { setMibean({ ...miBean, "CostingCenterCode": e }); console.log(e) }} fKey='Code' />
                            </div>
                            <div className="col-md-4">
                                <label>Código de Operación por Defecto</label>
                                <input type="text" className='form-control' value={miBean.OperationTypeCode} onChange={(e) => { setMibean({ ...miBean, "OperationTypeCode": e.target.value }) }} />
                            </div>
                            <div className="col-md-4">
                                <label>Código de Producto por Defecto</label>
                                <input type="text" className='form-control' value={miBean.ProductCode} onChange={(e) => { setMibean({ ...miBean, "ProductCode": e.target.value }) }} />
                            </div>
                            <div className="col-md-4">
                                <label>Código de Producto Destino</label>
                                <input type="text" className='form-control' value={miBean.DestinityProduct} onChange={(e) => { setMibean({ ...miBean, "DestinityProduct": e.target.value }) }} />
                            </div>
                            <div className="col-md-4">
                                <label>Código Catálogo Externo 1</label>
                                <input type="text" className='form-control' value={miBean.OtherPUCCode1} onChange={(e) => { setMibean({ ...miBean, "OtherPUCCode1": e.target.value }) }} />
                            </div>
                            <div className="col-md-4">
                                <label>Código Catálogo Externo 2</label>
                                <input type="text" className='form-control' value={miBean.OtherPUCCode2} onChange={(e) => { setMibean({ ...miBean, "OtherPUCCode2": e.target.value }) }} />
                            </div>
                            <div className="col-md-4">
                                <label>Código Catálogo Externo 3</label>
                                <input type="text" className='form-control' value={miBean.OtherPUCCode3} onChange={(e) => { setMibean({ ...miBean, "OtherPUCCode3": e.target.value }) }} />
                            </div>
                            <div className="col-md-4">
                                <label>Requiere Área de Negocio ?</label>
                                <BasicSwitch label="No / Si" estado={miBean.RequiresBusinessCore} eventChange={(e: any) => { setMibean({ ...miBean, "RequiresBusinessCore": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-4">
                                <label></label>
                                <BasicSwitch label="Definir Unidad de Negocio ?" estado={miBean.UseBusinessCoreParam} eventChange={(e: any) => { setMibean({ ...miBean, "UseBusinessCoreParam": e }) }}></BasicSwitch>
                            </div>
                            {miBean.UseBusinessCoreParam && <>
                                <div className="col-md-6">
                                    <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={miBean.IDBusinessCore} onChange={(e) => { setMibean({ ...miBean, "IDBusinessCore": e.IDBusinessCore }) }} />
                                </div>

                            </>}
                            <div className="col-md-4">
                                <SelectAccountantTree label='Mapeo a Cuenta de Costo' jsonCode={miBean.CostAccountantIDStr} onChange={(e) => { setMibean({ ...miBean, "CostAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-4">
                                <Selecttofile label='Tipo de Paquete de Pago' idSelector={miBean.IDPaymentFile} onChange={(e: any) => { setMibean({ ...miBean, "IDPaymentFile": e }) }} />
                            </div>
                            <div className="col-md-4">
                                <SelectTypeProcees label='Tipo de Proceso' idSelector={miBean.ProcessType} onChange={(e: any) => { setMibean({ ...miBean, "ProcessType": e }) }} />
                            </div>

                        </>
                    }

                    {miBean.IDLn ?
                        <div className="col-md-12 mt-2">
                            <BasicButton disable={(cuenta === 0 && nombre === '')} icon="ri-edit-line" eventClick={updateAccountant}>Editar</BasicButton>
                        </div>
                        :
                        <div className="col-md-12">
                            <BasicButton disable={(cuenta === 0 && nombre === '')} icon="ri-edit-line" eventClick={createAccountant}>Crear</BasicButton>
                        </div>
                    }
                    {/* <PrintJson json={miBean} /> */}
                </div>
            </Modal>
            <ModalConfirm modal={confirmDelete.modal} updateModal={confirmDelete.setModal} eventModal={() => { deleteAccountant(bean.IDLn) }}>
                <strong>Eliminar cuenta {bean.Name}</strong>
            </ModalConfirm>

            <Modal modal={siif.modal} updateModal={siif.setModal}>
                    <ConfigSIIFTCON6ValueByAccountantID accountantID={miBean.JsonCode} />
            </Modal>



        </>
    )
}
